import { useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { PopupUpgrade } from '../../../../../userManagement/subscriptionPayment/common/popupUpgrade'

export const Upgrade = () => {
  const [isShow, setShow] = useState(false)

  //Actions
  const handelUpgrade = () => {
    setShow(true)
  }

  return (
    <div className="flexColumn justifyContentCenter alignItemsCenter">
      <Element
        style={{
          fontWeight: 500,
          fontSize: 20,
          color: '#191D25',
          padding: '6px 24px',
          backgroundColor: '#FFCD60',
          borderRadius: 4,
          marginBottom: 6,
          cursor: 'pointer',
          textTransform: 'uppercase',
        }}
        onClick={handelUpgrade}
      >
        <Translate value="score.standard.UPGRADE_NOW" />
      </Element>
      <Element
        elementName="p"
        style={{
          lineHeight: '16px',
          color: '#3A414B',
          padding: '6px 24px',
          fontStyle: 'italic',
          paddingBottom: 0,
        }}
      >
        <Translate value="score.standard.REPORT" />
      </Element>
      {isShow && <PopupUpgrade isShow={isShow} setIsShow={setShow} />}
    </div>
  )
}
